import React, { useMemo } from 'react';
import { Link } from 'gatsby';

import SliderBtn from 'components/UI/SliderBtn';
import useBlogPosts from 'hooks/graphql/useBlogPosts';
import useDeviceState from 'hooks/useDeviceState';
import useReusableBlocks from 'hooks/graphql/useReusableBlocks';
import { MOBILE_KEY } from 'constants/devices.js';

import * as styles from './postNavigate.module.scss';

const PostNavigate = ({ data }) => {
  const allPosts = useBlogPosts();
  const device = useDeviceState();

  const {
    forms_ui: {
      buttons: { nextPost: nextPostBtn, previewPost: previewPostBtn },
    },
  } = useReusableBlocks();

  const currentIndex = allPosts.findIndex(({ id }) => id === data.id);

  const previewPost = useMemo(
    () => (currentIndex !== 0 ? allPosts[currentIndex - 1] : null),
    [allPosts, currentIndex]
  );

  const nextPost = useMemo(
    () => (currentIndex < allPosts.length ? allPosts[currentIndex + 1] : null),
    [allPosts, currentIndex]
  );

  return (
    <div className={styles.wrapper}>
      <div>
        {previewPost && (
          <Link to={previewPost.uri}>
            <SliderBtn Tag="div" type="left" mod="white" />

            {device !== MOBILE_KEY ? (
              <span>{previewPost.title}</span>
            ) : (
              <span>{previewPostBtn}</span>
            )}
          </Link>
        )}
      </div>
      <div>
        {nextPost && (
          <Link to={nextPost.uri}>
            {device !== MOBILE_KEY ? (
              <span>{nextPost.title}</span>
            ) : (
              <span>{nextPostBtn}</span>
            )}
            <SliderBtn Tag="div" type="right" mod="white" />
          </Link>
        )}
      </div>
    </div>
  );
};

export default PostNavigate;
